import { useTranslation } from "react-i18next";
import TitleUpdater from "../../components/common/title/TitleUpdater";
import RecentOrders from "../../components/dashboard/recent-orders/RecentOrders";

import StatisticCards from "../../components/dashboard/statistic-cards/StatisticCards";
import QuickActions from "../../components/dashboard/QuickActions";
import ChartsSection from "../../components/dashboard/charts/ChartsSection";
import styles from "./Dashboard.module.scss";

const Dashboard = () => {
  const { t } = useTranslation("translation");

  return (
    <div className={styles.dashboard}>
      <TitleUpdater title={t("overview")} />
      <StatisticCards />
      <QuickActions />
      <ChartsSection />
      <RecentOrders />
    </div>
  );
};

export default Dashboard;
